import { axios } from "../../lib/axios";

export const DeleteMockupExam = (mockupId: string) => {
    return axios.delete(`/certificate-exam/mockup-exam/${mockupId}`)
        .then(response => response.data);
};

